import { createSelector } from '@reduxjs/toolkit';

import { ArtworksState } from '@definitions/artworks.types';

import { GlobalState } from '../createStore';

export const selectArtworksDomain = (state: GlobalState) => state.artworks;

export const selectGridSize = createSelector(selectArtworksDomain, (state: ArtworksState) => state.gridSize);
export const selectArtworks = createSelector(selectArtworksDomain, (state: ArtworksState) => state.artworks);
export const selectLoading = createSelector(selectArtworksDomain, (state: ArtworksState) => state.loading);
export const selectCurrentPage = createSelector(selectArtworksDomain, (state: ArtworksState) => state.currentPage);
export const selectFavoriteArtworks = createSelector(
  selectArtworksDomain,
  (state: ArtworksState) => state.favoriteArtworks
);
export const selectMeta = createSelector(selectArtworksDomain, (state: ArtworksState) => state.meta);
export const selectArtworkDynamicData = createSelector(
  selectArtworksDomain,
  (state: ArtworksState) => state.artworkDynamicData
);
